export const MATH_TEST_REQUEST = 'MATH_TEST_REQUEST';
export const MATH_TEST_RECEIVE = 'MATH_TEST_RECEIVE';
export const MATH_TEST_ERROR = 'MATH_TEST_ERROR';



// WEBPACK FOOTER //
// ./src/store/mathTest/actionTypes.js